import React, { useEffect, useReducer, useCallback } from 'react'
import axios from 'axios'
import { useTranslation } from 'react-i18next'
import Loading from '../Loading'
// import cookie from 'js-cookie'
import api from '../../api/client'
// import useLogOut from 'lib/useLogOut'
import useAlert from 'lib/useAlert'
import { logOutUserSelector, tokenSelector, userSelector, useUserStore } from 'store/userInfo.store'


const LOADING = 'loading'
const LOADING_DONE = 'loading_done'
const LoadingInterceptor = () => {
  const initialState = { loading: false }
  const {openAlert} = useAlert()
  const {t} = useTranslation()
  function reducer(_, action) {
    switch (action.type) {
      case LOADING:
        return { loading: true }
      case LOADING_DONE:
        return { loading: false }
      default:
        throw new Error()
    }
  }

  const [state, dispatch] = useReducer(reducer, initialState)
  // const {logOut} = useLogOut()
  const currentUser = useUserStore(userSelector)
  const token = useUserStore(tokenSelector)
  const logOutUser = useUserStore(logOutUserSelector)
  // const getCurrentUser = useUserStore(getUserSelector)
  const requestAddCount = (() => {
    let count = 0
    return (value) => {
      if (count >= 0) {
        count += value
      }
      if (count < 0) {
        count = 0
      }
      return count
    }
  })()

  const hideLoading = () => {
    if (requestAddCount(-1) === 0) {
      dispatch({ type: LOADING_DONE })
    }
  }
  // const cbGetCurrentUser = useCallback(getCurrentUser,[])
  const requestInterceptor = async (config) => {
    // console.log("interceptor",!token , !currentUser?.id, token,currentUser.id,(!token && currentUser?.userNotLoaded))
    // console.log({currentUser})
    // api.interceptors.response.use(({data})=>console.log(data));
    // const token = cookie.get('token')
    // const user = cookie.get('user')
    if (
      !token &&
      !Number(currentUser?.id >0) &&
      config.url.indexOf('getaccesstoken') === -1 &&
      config.url.indexOf('forgotPassword') === -1 &&
      config.url.indexOf('resetPasswordByUser') === -1 &&
      config.url.indexOf('resetMail') === -1
    ) {
      // console.log("hey dasd ad as das da das dasd asd asd asd ")
      throw new axios.Cancel('Operation canceled by the user.')
      
    }
    if (token) config.headers.Authorization = 'Bearer ' + token
    requestAddCount(1)
    dispatch({ type: config.url !== 'pivot/addOrUpdate' ? LOADING : LOADING_DONE })
    // console.log("config interceptor",config)
    return config
  }

  const requestErrorInterceptor = (error) => {
    hideLoading()
    return Promise.reject(error)
  }

  const responseInterceptor = (response) => {
   
    hideLoading()
    const {data:{P_RESULT_MESSAGE}} = response
    // console.log(P_RESULT_MESSAGE?.slice(0,18))
    if(P_RESULT_MESSAGE?.slice(0,18) === 'SqlErrm :ORA-20002'){
      logOutUser()
      // logOut()
      // window.location.reload()
      openAlert('error',true,t('error_token_time_out'))
    }
    return response
  }

  const responseErrorInterceptor = (error) => {
    hideLoading()
    
    if (error.message === 'Operation canceled by the user.') {
      
      return Promise.resolve({ data: {}, status: 401 })
    }
    if (error.message === 'Request failed with status code 401') {
      logOutUser()
      // cookie.remove('token')
      // cookie.remove('user')
      // window.location.reload(false)
    } else return Promise.reject(error)
  }

  const cbRequestInterceptor = useCallback(requestInterceptor, [token])
  const cbRequestErrorInterceptor = useCallback(requestErrorInterceptor, [])

  const cbResponseInterceptor = useCallback(responseInterceptor, [])
  const cbResponseErrorInterceptor = useCallback(responseErrorInterceptor, [])

  useEffect(() => {
    const requestId = api.interceptors.request.use(cbRequestInterceptor, cbRequestErrorInterceptor)
    const responseId = api.interceptors.response.use(cbResponseInterceptor, cbResponseErrorInterceptor)

    return () => {
      api.interceptors.request.eject(requestId)
      api.interceptors.response.eject(responseId)
    }
  }, [cbRequestErrorInterceptor, cbRequestInterceptor, cbResponseErrorInterceptor, cbResponseInterceptor])

  return <>{state.loading && <Loading />}</>
}

export default LoadingInterceptor
